import React from "react";

import { Modal } from "shared/components/Modal";

import { DeactivateEmployeeModalProps } from "./interfaces";

const DeactivateEmployeeModal = ({
  name,
  submit,
  submitting,
}: DeactivateEmployeeModalProps) => (
  <Modal
    title={`Deactivate ${name}?`}
    submit={submit}
    submitButtonLabel="Deactivate"
    submitting={submitting}
  >
    <Modal.Body>
      <p>{name} will lose login access immediately and be unassigned from all properties they manage. You can reactivate them later by toggling on &ldquo;Show deactivated&rdquo; on the Employees page.</p>
    </Modal.Body>
  </Modal>
);

export default DeactivateEmployeeModal;
